import { appleDarkTokens } from './appleDarkTokens';
import { appleLightTokens } from './appleLightTokens';
import type { DesignThemeName, DesignThemeTokens } from './types';

export const designThemeRegistry: Record<DesignThemeName, DesignThemeTokens> = {
  light: appleLightTokens,
  dark: appleDarkTokens,
};

export const getDesignThemeTokens = (theme: DesignThemeName): DesignThemeTokens =>
  designThemeRegistry[theme];

export const isDesignThemeName = (value: string): value is DesignThemeName =>
  value === 'light' || value === 'dark';

export { appleLightTokens, appleDarkTokens };
